export default "__VITE_PUBLIC_ASSET__69a547dc__"